import axios from "axios"

import { API } from "."

export const readVerify = async (data: string) => {
  return await API.get<void>(`/auth/verify`, {
    headers: {
      Authorization: `Bearer ${data}`,
    },
  })
}

// OTT 교환 (interceptor 설정 전에 호출되므로 별도 인스턴스 사용)
const ottClient = axios.create()
export const exchangeOtt = async (token: string) => {
  const response = await ottClient.post(`${import.meta.env.VITE_API_ENDPOINT}/auth/exchange-ott`, {
    token,
  })
  return response.data.data as { accessToken: string }
}
